// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  emailVerify: path(ROOTS_AUTH, '/email-verify')
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  page: {
    posts: path(ROOTS_DASHBOARD, '/posts'),
    post: path(ROOTS_DASHBOARD, '/posts/:title'),
    newPost: path(ROOTS_DASHBOARD, '/new-post')
  },
  enquiry: {
    root: path(ROOTS_DASHBOARD, '/enquiry'),
    conversation: path(ROOTS_DASHBOARD, '/enquiry/:conversationKey')
  },
  refrences: {
    root: path(ROOTS_DASHBOARD, '/refrences')
  },
  video: {
    root: path(ROOTS_DASHBOARD, '/video'),
    edit: path(ROOTS_DASHBOARD, '/video/:id'),
    new: path(ROOTS_DASHBOARD, '/video/new-video')
  },
  decision: {
    root: path(ROOTS_DASHBOARD, '/decisions'),
    edit: path(ROOTS_DASHBOARD, '/decisions/:id'),
    new: path(ROOTS_DASHBOARD, '/decisions/new-decisions')
  },
  guidlines: {
    root: path(ROOTS_DASHBOARD, '/guidlines'),
    edit: path(ROOTS_DASHBOARD, '/guidlines/:id'),
    new: path(ROOTS_DASHBOARD, '/guidlines/new-guidlines')
  },
  classifications: {
    root: path(ROOTS_DASHBOARD, '/classifications'),
    edit: path(ROOTS_DASHBOARD, '/classifications/:id'),
    new: path(ROOTS_DASHBOARD, '/classifications/new-classifications')
  },
  antibiotics: {
    root: path(ROOTS_DASHBOARD, '/antibiotics'),
    edit: path(ROOTS_DASHBOARD, '/antibiotics/:id'),
    new: path(ROOTS_DASHBOARD, '/antibiotics/new-antibiotics')
  },
  overview: {
    root: path(ROOTS_DASHBOARD, '/overview'),
    edit: path(ROOTS_DASHBOARD, '/overview/:id'),
    new: path(ROOTS_DASHBOARD, '/overview/new-overview')
  },
  categories: {
    root: path(ROOTS_DASHBOARD, '/categories'),
    edit: path(ROOTS_DASHBOARD, '/categories/:id'),
    new: path(ROOTS_DASHBOARD, '/categories/new-categories')
  },
  subcategories: {
    root: path(ROOTS_DASHBOARD, '/subcategories'),
    edit: path(ROOTS_DASHBOARD, '/subcategories/:id'),
    new: path(ROOTS_DASHBOARD, '/subcategories/new-subcategories')
  }
  // addToSub: {
  //   root: path(ROOTS_DASHBOARD, '/add_to_subcategories'),
  //   edit: path(ROOTS_DASHBOARD, '/add_to_subcategories/:id'),
  //   new: path(ROOTS_DASHBOARD, '/add_to_subcategories/new-add_to_subcategories')
  // }
};
